<template>
  <div class="m-live-betting">
    <Skeleton
      class="m-live-betting--inner"
      :loading="false"
      empty-size="small"
    >
      <template v-if="liveMatches.length">
        <MatchList
          :list="liveMatches"
          :current-market-id="marketId"
        />

        <ViewAll
          :url="viewAllUrl"
          :is-live="true"
          :count="liveMatchesCount"
        />
      </template>
    </Skeleton>
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useGlobalConfigStore } from '@ms/stores/globalConfig'
import MatchList from 'wap/match/MatchList.vue'
import ViewAll from '../components/ViewAll'
import useHomeStore from 'wap/stores/home'

const LIMIT_AUTO_UPDATE_COUNT = 4

export default {
  name: 'LiveBetting',
  components: {
    MatchList,
    ViewAll
  },
  props: {
    sportId: {
      type: String,
      default: '',
      required: true
    },
    marketId: {
      type: String,
      default: '',
      required: true
    },
    sportName: {
      type: String,
      default: '',
      required: true
    }
  },
  setup () {
    const store = useHomeStore()
    const { liveMatches, liveMatchesCount } = storeToRefs(store)
    return {
      liveMatches,
      liveMatchesCount
    }
  },
  computed: {
    viewAllUrl () {
      return { name: 'liveMatchList', params: { sportName: encodeURIComponent(this.sportName) } }
    }
  },
  watch: {
    'liveMatches.length' (val, oldVal) {
      if (val < LIMIT_AUTO_UPDATE_COUNT && oldVal >= LIMIT_AUTO_UPDATE_COUNT) {
        this.initAutoUpdate()
      }
    }
  },
  activated () {
    this.initAutoUpdate()
  },
  mounted () {
    this.initAutoUpdate()
  },
  deactivated () {
    clearTimeout(this._autotimer)
  },
  beforeDestroy () {
    clearTimeout(this._autotimer)
  },
  destroyed () {
    useHomeStore().resetLiveMatches()
  },
  methods: {
    async fetchSportMatches () {
      if (this._loading) return
      this._loading = true
      try {
        const { sportId } = this
        const exceptEventIds = this.liveMatches.map(x => x.eventId).join(',')
        await useHomeStore().getLiveMatches({ sportId, exceptEventIds })
      } catch (error) {
        if (error === 'canceled') return
      }
      this._loading = false
      this.initAutoUpdate()
    },
    initAutoUpdate () {
      if (this.liveMatches.length < LIMIT_AUTO_UPDATE_COUNT) {
        clearTimeout(this._autotimer)
        this._autotimer = setTimeout(this.fetchSportMatches, useGlobalConfigStore().refreshLiveMillisecond)
      }
    }
  }
}
</script>
